<div class="tpiq-paginated-table" id={{id}}>
  <div class="row">
    <div class="column">
      <div class="row" *ngIf="showSearch">
        <div class="medium-12 large-12 columns">
          <div class="float-left">
          </div>
          <div class="float-right">
            <div class="report-icon-header" style="padding-top: 10px !important; margin-left: 8px;">
              <i class="icon ion-ios-cloud-download-outline" data-toggle="je-export-dropdown"></i>
              <div class="dropdown-pane bottom export-dropdown" style="cursor: pointer" id="je-export-dropdown" data-dropdown data-hover="true" data-hover-pane="true" foundation>
                <div (click)="exportToFile('excel')" class="export-option">Export To Excel</div>
                <div (click)="exportToFile('pdf')" class="export-option">Export To PDF</div>
              </div>
            </div>
          </div>
          <div class="float-right">
            <button type="button" class="btn btn-primary search-btn">
              <i class="icon icon ion-search" [hidden]="!showSearchIcon" (click)="doSearch($event)"></i>
              <i class="icon icon ion-ios-close-outline close-icon" [hidden]="showSearchIcon" (click)="removeSearch($event)"></i>
            </button>
          </div>
          <div class="float-right">
            <form autocomplete="off">
              <input type="text" [hidden]="true" autocomplete="off"/>
              <label>
                <input type="text" class="search-field" placeholder="Search" [(ngModel)]="searchString" [ngModelOptions]="{standalone: true}" (keyup)="doSearch($event)"/>
              </label>
            </form>
          </div>
        </div>
      </div>
      <div style="overflow-y: auto;" [ngStyle]="{'height': height}" libScrollEvent (onscroll)="handleScroll($event)" [bottomOffset]="100">
        <table>
          <thead>
          <tr>
            <th *ngFor="let column of columns" attr.sortable="{{column['sortable'] == false? false : true}}" [ngClass]="column.classes +' ' +column.headerclasses">
              <span *ngIf="column.type !='html'">{{column.title}}</span>
              <span *ngIf="column.type =='html'" [innerHTML]="column.title | safeHtml"></span>
              <span class="float-right">
                  <span *ngIf="column.sortType == 'asc'">
                    <i class="icon ion-ios-arrow-up sort-indicator"></i>
                  </span>
                  <span *ngIf="column.sortType == 'desc'">
                    <i class="icon ion-ios-arrow-down sort-indicator"></i>
                  </span>
                </span>
            </th>
          </tr>
          </thead>
          <tbody>
          <ng-template [ngIf]="data && data.length == 0">
            <tr class="text-center">
              <td [attr.colspan]="columns.length">
                <div class="callout text-center">
                  <p>No Results Found.</p>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template [ngIf]="data && data.length > 0">
            <tr *ngFor="let obj of data" data-id="{{obj[selector]}}">
              <!-- Need to make ngclass better -->
              <td *ngFor="let column of columns" [ngClass]="column.classes + ' ' +obj[column.name+'-class']">
                <span *ngIf="column.type !='html' && column.type !='input-search' && column.type !='dropdown' && column.type !='conditionalDropdown' && column.type !='subStatusDropDown' && column.type !='TypeStatusDropDown' && column.type !='input' && column.type !='input-currency' && column.type != 'billing-input-currency'">{{obj[column.name]}}</span>

                <ng-template [ngIf]="obj.isEditable">
                  <ng-template [ngIf]="column.type=='input-search'">
                    <app-tpiq-input-search [setData]="column.data" [setColName]="column.name" [setPlaceHolder]="column.placeholder" [setMasterRow]="obj" [setSearchKey]="'name'" [setValueKey]="'id'"
                                        [setDefaultValue]="obj[column.name].id" (onValueSelect)="propagateSelection($event)"></app-tpiq-input-search>
                  </ng-template>
                  <ng-template [ngIf]="column.type=='dropdown'">
                    <app-tpiq-select-dropdown [setData]="column.data" [setColName]="column.name" [setPlaceHolder]="column.placeholder" [setMasterRow]="obj" [setSearchKey]="'value'" [setValueKey]="'key'"
                                           [setDefaultValue]="obj[column.name]" (onValueSelect)="propagateDropdownSelection($event)"></app-tpiq-select-dropdown>
                  </ng-template>
                  <ng-template [ngIf]="column.type=='conditionalDropdown'">
                    <app-tpiq-select-dropdown [setData]="getDropdownData(column.data, obj[column.name])" [setPlaceHolder]="column.placeholder" [setMasterRow]="obj" [setSearchKey]="'value'" [setValueKey]="'key'"
                                           [setDefaultValue]="obj[column.name]" (onValueSelect)="propagateDropdownSelection($event)"></app-tpiq-select-dropdown>
                  </ng-template>
                  <ng-template [ngIf]="column.type=='subStatusDropDown'">
                    <app-tpiq-select-dropdown [setData]="getSubStatusChange(column.data, obj[column.name], obj)" [setColName]="column.name" [setPlaceHolder]="column.placeholder" [setMasterRow]="obj" [setSearchKey]="'value'" [setValueKey]="'key'"
                                           [setDefaultValue]="obj[column.name]" (onValueSelect)="propagateDropdownSelection($event)"></app-tpiq-select-dropdown>
                  </ng-template>
                  <ng-template [ngIf]="column.type=='TypeStatusDropDown'">
                    <app-tpiq-select-dropdown [setData]="getTypeStatusChange(column.data, obj[column.name], obj)" [setColName]="column.name" [setPlaceHolder]="column.placeholder" [setMasterRow]="obj" [setSearchKey]="'value'" [setValueKey]="'key'"
                                           [setDefaultValue]="obj[column.name]" (onValueSelect)="propagateDropdownSelection($event)"></app-tpiq-select-dropdown>
                  </ng-template>
                  <ng-template [ngIf]="column.type=='labelsDropdown'">
                    <app-tpiq-select-dropdown [setData]="column.data" [setColName]="column.name" [setPlaceHolder]="column.placeholder" [setMasterRow]="obj" [setSearchKey]="'labelName'" [setValueKey]="'labelId'"
                                           [setDefaultValue]="obj['label']" (onValueSelect)="propagateDropdownSelection($event)"></app-tpiq-select-dropdown>
                  </ng-template>
                  <ng-template [ngIf]="column.type=='input'">
                    <input type="text" class="input-text" [(ngModel)]="obj[column.name]" (blur)="onInputChange(obj, column.name)"/>
                  </ng-template>
                  <ng-template [ngIf]="column.type=='input-currency'">
                    <input type="text" style="float: left;clear: both;width: 70% !important;" class="input-text" model-numeral [format]="'$0,0.00'" [locale]="companyCurrency" [(ngModel)]="obj[column.name]" (blur)="onInputChange(obj, column.name)"/>
                    <span class="icon-update"><i class="material-icons ion-checkmark-circled icon-input-update" (click)="updateWithClickIcon(obj, column)"></i></span>
                  </ng-template>
                  <ng-template [ngIf]="column.type=='billing-input-currency'">
                    <input *ngIf="obj[column.name] !== ''" type="text" style="float: left;clear: both;width: 70% !important;" class="input-text" model-numeral [format]="'$0,0.00'" [locale]="companyCurrency" [(ngModel)]="obj[column.name]" (change)="onInputChange(obj, column.name)"/>
                    <span class="icon-update" *ngIf="!column.hideUpdateIcon"><i class="material-icons ion-checkmark-circled icon-input-update" (click)="updateWithClickIcon(obj, column)"></i></span>
                  </ng-template>
                </ng-template>
                <ng-template [ngIf]="!obj.isEditable">
                  <ng-template [ngIf]="column.type=='input-search'">
                    <span>{{obj[column.name].name}}</span>
                  </ng-template>
                  <ng-template [ngIf]="column.type=='dropdown' || column.type=='conditionalDropdown' || column.type=='subStatusDropDown' || column.type=='TypeStatusDropDown' || column.type=='input' || column.type=='input-currency' || column.type=='labelsDropdown' || column.type == 'billing-input-currency'">
                    <span *ngIf="column.type != 'dropdown' && column.type != 'labelsDropdown'">{{obj[column.name]}}</span>
                    <div *ngIf="column.type == 'dropdown'" style="text-overflow: ellipsis; max-width: 180px; overflow: hidden;">{{obj[column.name]}}</div>
                    <div *ngIf="column.type == 'labelsDropdown'" style="text-overflow: ellipsis; max-width: 180px; overflow: hidden;">{{obj['labelname']}}</div>
                  </ng-template>
                </ng-template>
                <span *ngIf="column.type =='html'" [innerHTML]="obj[column.name] | safeHtml"></span>
              </td>
            </tr>
          </ng-template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
